import DashboardLayout from '../../components/dashboard/DashboardLayout';
import AllBookings from '../guest/AllBookings';

const MyStayPage = () => {
  return (
    <DashboardLayout>
      <AllBookings />
    </DashboardLayout>
  );
};

export default MyStayPage; 